<template>
    <div class="round-list-box">
        <div class="round-list-table">
            <el-table :data="roundList" border size="mini" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-340" >
                <el-table-column label="询价轮次" prop="lcNum" align="center" :show-overflow-tooltip="true" width="80"> </el-table-column>
                <el-table-column prop="fbTime" label="本轮询价发布日期" :show-overflow-tooltip="true"  width="150"> </el-table-column>
                <el-table-column prop="bjJzTime" label="本轮询价截止日期" :show-overflow-tooltip="true" width="150"> </el-table-column>
                <el-table-column prop="bjActEndTime" label="本轮实际完结日期" :show-overflow-tooltip="true" width="150"> </el-table-column>
                <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" > </el-table-column>
                <el-table-column prop="finishUserName" label="完结人" :show-overflow-tooltip="true" > </el-table-column>
                <el-table-column prop="" label="询报价详情" :show-overflow-tooltip="true" >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showBjInfo(scope.row)">询报价详情 </el-button>
                    </template>
                </el-table-column>
                <!-- 供应商轮次状态 -->
                <el-table-column prop="gysOrderState" v-if="checkRole('gys_role')" label="报价状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gysOrderState == 1">待参与</span>
                        <span v-if="scope.row.gysOrderState == 2">已放弃</span>
                        <span v-if="scope.row.gysOrderState == 3">报价中</span>
                        <span v-if="scope.row.gysOrderState == 4">报价已提交</span>
                        <span v-if="scope.row.gysOrderState == 5">已中标</span>
                        <span v-if="scope.row.gysOrderState == 6">未中标</span>
                    </template>
                </el-table-column>
                <!-- 采购员轮次状态 -->
                <el-table-column prop="status" v-if="checkRole('cgy_role')" label="发布状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">未开始</span>
                        <span v-if="scope.row.status == 1">报价中</span>
                        <span v-if="scope.row.status == 2">已完结</span>
                        <span v-if="scope.row.status == 3">已开标</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" v-if="checkRole('cgy_role')" label="操作" width="290">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleFun(1,scope.row)" :disabled="scope.row.status != 0">编辑</el-button>
                        <el-button type="text" size="small" @click="handleFun(2,scope.row)" :disabled="scope.row.status != 0">删除</el-button>
                        <el-button type="text" size="small" @click="handleFun(3,scope.row)" :disabled="scope.row.status != 1">完结</el-button>
                        <el-button type="text" size="small" @click="handleFun(4,scope.row)" :disabled="scope.row.status != 0">发布询价</el-button>
                        <el-button type="text" size="small" @click="handleFun(5,scope.row)" :disabled="scope.row.status != 2 || orderInfo.orderState >2 ">开标</el-button>
                       <!-- <el-button type="text" size="small" :disabled="scope.row.status < 1" @click="exportBjb(scope.row)">导出报价表</el-button> -->
                    </template>
                </el-table-column>
                 <el-table-column prop="" v-if="checkRole('gys_role') && orderInfo.gysOrderState == 3" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" :disabled="scope.row.status != 1" @click="editBjInfo(scope.row)">编辑报价</el-button>
                        <el-button type="text" size="small" :disabled="scope.row.status != 1" @click="submitBj(scope.row)">提交报价</el-button>
                      <!--  <el-button type="text" size="small" :disabled="scope.row.status != 1" @click="exportBjb(scope.row)">导出报价表</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :visible.sync="openDialog" custom-class="add-ground-dialog" width="calc(100% - 20px)" top="10px" :title="title" :close-on-click-modal="false">
            <el-form label-width="130px" ref="groundForm" :model="form" :rules="rules" size="small">
                <el-row>
                    <el-col :span="24">
                        <div class="add-gys-head">
                            <!-- <el-button size="small" type="primary" v-if="!showSelectGys" :disabled="ids.length<1" @click="showSelectGys=true">指定供应商</el-button> -->
                            <el-button size="small" type="primary" v-if="!showSelectGys" :disabled="ids.length<1" @click="bindGys">邀请供应商</el-button>
                            <el-button size="small" type="primary" v-if="form.id"  @click="addGoods">新增物料</el-button>
                            <el-select v-model="selectGys" size="small" v-if="showSelectGys" :multiple="orderInfo.xjFs == 3 || orderInfo.xjFs == 1" placeholder="请选择供应商" style="width:calc(100% - 130px)">
                                <el-option v-for="item in gysUsers" :key="item.value" :label="item.label" :value="item.value">{{item.label}}({{item.name}})</el-option>
                            </el-select>
                            <el-button size="small" type="primary" v-if="showSelectGys" @click="selectSubmit">确定</el-button>
                            <el-button size="small" v-if="showSelectGys" @click="showSelectGys=false" style="margin-left: 0px">取消</el-button>
                        </div>
                        <el-table v-if="openDialog" :data="form.goodsList" border ref="goodsTable" size="mini" :height="`calc(100vh - 400px)`" :row-key="tableRow" :header-cell-style="headerCellStyle" style="width: 100%"  @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="40" align="left"> </el-table-column>
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <div v-if="props.row.gysInfos.length" class="tag-box" style="padding:5px 10px 0px 10px;background:#eee;">
                                        <el-tag  v-for="user in props.row.gysInfos" :key="user.id" style="margin-right:5px;margin-bottom:5px;">
                                            {{user.name}}
                                            <span v-if="user.cname">({{user.cname}})</span>
                                            <i class="el-icon-delete" @click="delGys(props.row,user)" style="cursor: pointer;margin-left:5px"></i>
                                        </el-tag>
                                    </div>
                                    <div class="no-round-list" v-else>暂无供应商信息</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="wzCode" label="物料编码" :show-overflow-tooltip="true" width="100"> </el-table-column>
                            <el-table-column prop="wzName" label="物料名称" :show-overflow-tooltip="true" width="120"> </el-table-column>
                            <el-table-column prop="wzClassCode" label="物资分类" :show-overflow-tooltip="true"> </el-table-column>
                            <el-table-column prop="wzSspce" label="规格" :show-overflow-tooltip="true" width="120"> </el-table-column>
                            <el-table-column prop="wzModel" label="型号" :show-overflow-tooltip="true" width="120"> </el-table-column>
                            <!-- <el-table-column prop="figueNumber" label="图号" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
                            <!-- <el-table-column prop="paramPz" label="参数配置" :show-overflow-tooltip="true"> </el-table-column> -->
                            <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true" width="50"> </el-table-column>
                            <el-table-column prop="num" label="需求数量" :show-overflow-tooltip="true" width="120"> </el-table-column>
                            <el-table-column prop="xqDate" label="需求日期" :show-overflow-tooltip="true" width="120"> </el-table-column>
                            <!-- <el-table-column prop="fixedPrice" label="限价" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
                            <el-table-column prop="bcExplain" label="行备注" :show-overflow-tooltip="true"> </el-table-column>
                            <!-- <el-table-column prop="isXqYp" label="需要样品" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
                            <el-table-column label="附件" width="95">
                                <template slot-scope="scope">
                                    <el-tag v-if="!scope.row.src && (scope.row.rowNo || !form.id)" type="info">无附件
                                    </el-tag>
                                    <el-link v-if="scope.row.src" :underline="false" :href="baseURL+scope.row.src" target="_blank">
                                        <el-tag type="success">查看附件</el-tag>
                                    </el-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isConcatTax" label="是否含税" :show-overflow-tooltip="true" width="120"> </el-table-column>
                            <el-table-column prop="taxRate" label="税率" :show-overflow-tooltip="true" :formatter="formatTaxRate" width="120"> </el-table-column>

                            <el-table-column prop="num" label="操作" fixed="right" :show-overflow-tooltip="true" width="80">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" :disabled="form.goodsList.length==1" @click="delRow(scope.row)">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="16">
                        <el-form-item label="报价截止日期:" prop="bjJzTime">
                             <el-date-picker
                                v-model="form.bjJzTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                                </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="报价轮次:" prop="bjJzTime">
                            <span>第{{form.id?form.lcNum:roundList.length+1}}轮</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                 <el-row >
                    <el-col :span="16">
                        <el-form-item label="备注:" prop="remark">
                             <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入备注"
                                v-model="form.remark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="16">
                        <el-form-item label="采购说明:" prop="buyerRemark">
                             <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入采购说明"
                                maxlength="300"
                                v-model="form.buyerRemark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openDialog = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitForm(1)" size="small" :disabled="showSelectGys">保存</el-button>
                <!-- <el-button type="primary" @click="submitForm(2)" size="small" :disabled="showSelectGys">保存并发布</el-button> -->
            </span>
        </el-dialog>
        <!-- 询价详情 -->
        <EnquiryDetail ref="EnquiryDetailRef" :orderInfo="orderInfo" @callback="EnquiryDetailCallback"/>
        <!-- 选择供应商 -->
        <SelectGys ref="SelectGysRef" :orderInfo="orderInfo" @callback="SelectGysCallback" />
        <!-- 编辑询价单时 新增物料 -->
        <SelectOrderGoods ref="SelectOrderGoodsRef" :orderInfo="orderInfo" @callback="SelectOrderGoodsCallback" />
    </div>
</template>
<script>
import { inquiryDetailList,addInquiryRound,editInquiryRound,getInquiryRoundList,getInquiryRoundDetail,srmXjdelBid,finishInquiryRound,publishInquiryRound,submitOrderBj,kaibiaoInquiryRound,exportInquiryRoundDetail } from '@/api/srm/inquiryDetail.js'
import { supplierInfoList } from '@/api/gys/supplierInfo.js'
import { createHash } from '../../../utils/app.js'
import EnquiryDetail from '@/components/EnquiryDetail'
import SelectGys from '@/components/SelectGys'
import SelectOrderGoods from '@/components/SelectOrderGoods'
export default {
    props:['hId','pageFlag','orderInfo'],
    components:{
        EnquiryDetail,SelectGys,SelectOrderGoods
    },
    computed:{
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        userRoles:function(){
            return this.$store.getters['user/roles'];
        },
    },
    data(){
        return {
            activeNames: [],
            roundList:[],
            form:{
                id:'',
                bjJzTime:null,
                remark:'',
                buyerRemark:'',
                goodsList:[],
                // editFlag:false,
                // state:'',   // 0 还未保存 1：未开始 2：报价中 3：已结束
            },
            rules:{
                bjJzTime: [{
                    required: true,
                    message: '请选择截止日期',
                    trigger: 'blur'
                }],
            },
            openDialog:false,
            title:'',
            ids:[],
            idsObj:{},
            expandRowkeys:[],
            // 选择供应商
            showSelectGys:false,
            gysUsers:[],
            selectGys:[],
        }
    },
    created(){
        console.log(this.orderInfo)
        this.getInquiryRoundList();
    },
    methods:{
        // 导出报价表
        async exportBjb(row){
            console.log(row)
            let _this = this;
            const {
                data: res
            } = await exportInquiryRoundDetail({id:row.id})
            console.log(res)
            let blob = new Blob([res], {
                type: `"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"`
            });
            let objectUrl = URL.createObjectURL(blob);
            let link = document.createElement("a");
            let fname = `报价表.xlsx`; //下载文件的名字+后缀名
            link.href = objectUrl;
            link.setAttribute("download", fname);
            document.body.appendChild(link);
            link.click();
            // console.log(res)
            // if(res.code == 0){

            // }
        },
        // 查看询价详情
        showBjInfo(row){
            let _this = this;
            _this.$refs.EnquiryDetailRef.showDialog(row,false,'询价明细');
        },
        // 编辑报价信息
        editBjInfo(row){
            let _this = this;
            _this.$refs.EnquiryDetailRef.showDialog(row,true,'编辑报价');
        },
        // 定标
        editTenderInfo(type){
            let _this = this;
            _this.$refs.EnquiryDetailRef.showDialog(null,false,'定标',true,type);
        },
        // 操作
        handleFun(type,row){
            let _this = this;
            if(type == 1){  // 编辑
                // 获取报价详情
                console.log(row)
                if(this.$refs["groundForm"] !== undefined){
                    this.$refs["groundForm"].resetFields();
                }
                this.form = {
                    // id:`new_${createHash()}`,
                    lcNum:row.lcNum,
                    id:row.id,
                    bjJzTime:row.bjJzTime,
                    remark:row.remark,
                    buyerRemark:this.orderInfo.buyerRemark,
                    goodsList:[],
                };
                this.getOrderDetailList((list)=>{   // 获取物料列表
                    // this.form.goodsList=list;
                    // 获取供应商数据
                    this.getRoundGysInfo(row.id,(datas)=>{  // 获取轮次详情
                        console.log(this.form)
                        console.log(datas)
                        let gysObj = {};
                        datas.forEach((good)=>{
                            gysObj[`id_${good.inquiryDetail.id}`] = good.gysInfoList||[];
                        });
                        console.log(gysObj)
                        list.forEach((goods)=>{
                            goods['gysInfos']=[];
                            if(gysObj[`id_${goods.id}`]){
                                gysObj[`id_${goods.id}`].forEach((gys)=>{
                                    goods['gysInfos'].push({
                                        id:gys.supplierInfo.id,
                                        name:gys.supplierInfo.name,
                                        cname:gys.supplierInfo.qyShort
                                    })
                                })
                                this.form.goodsList.push(goods);    // 不默认把所有物料带上
                            }
                            // else{
                            //     goods['noInList'] = true;
                            // }
                            // this.form.goodsList.push(goods);    // 默认非本轮次的物料带上
                        })
                        // return
                        this.openDialog=true;
                        this.title = '编辑报价轮次';
                        this.$nextTick(()=>{
                            this.handleConnectionSearch()
                        })
                        // console.log(this.orderInfo)
                    })
                })
            }
            if(type == 2){  // 删除
                _this.confirm({
                    text: '确认删除吗',
                    tip: '警告',
                    type: '',
                    fn: function(param) {
                        srmXjdelBid(param).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.getInquiryRoundList();
                                _this.$emit('callback',{type:'updateInfo'}); // 更新顶部信息
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    },
                    data: { id: row.id } //参数对象 主要回调函数用
                });
            }
            if(type == 3){  // 完结
                _this.confirm({
                    text: '确认完结吗',
                    tip: '提示',
                    type: 'info',
                    fn: function(param) {
                        finishInquiryRound(param).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.getInquiryRoundList();
                                _this.$emit('callback',{type:'updateInfo'}); // 更新顶部信息
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    },
                    data: { id: row.id } //参数对象 主要回调函数用
                });
            }
            if(type == 4){  //发布询价 一个订单同时只能存在一个询价中状态的询价轮次
                publishInquiryRound({id:row.id}).then(response => {
                    if (response.data.code === 0) {
                        _this.$success(response.data.msg);
                        _this.getInquiryRoundList();
                        _this.$emit('callback',{type:'updateInfo'}); // 更新顶部信息
                    } else {
                        _this.$fail(response.data.msg);
                    }
                });
            }
            if(type == 5){  // 开标
                _this.confirm({
                    text: '确认开标吗',
                    tip: '提示',
                    type: 'info',
                    fn: function(param) {
                        kaibiaoInquiryRound(param).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.getInquiryRoundList();
                                _this.$emit('callback',{type:'updateInfo'}); // 更新顶部信息
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    },
                    data: { id: row.id } //参数对象 主要回调函数用
                });
             }
            // srmXjdelBid,finishInquiryRound,publishInquiryRound
        },
        // 编辑物料时 新增物料
        addGoods(){
            let obj = {}
            this.form.goodsList.forEach((item)=>{
                obj[item.id] = true
            })
            this.$refs.SelectOrderGoodsRef.disGoodsIds= obj;
            this.$refs.SelectOrderGoodsRef.openDialog= true;
            this.$refs.SelectOrderGoodsRef.getList(this.orderInfo.id);
        },
        // 获取轮次详情
        getRoundGysInfo(id,callback){
            getInquiryRoundDetail({id:id}).then(({data: res})=>{
                if(res.code == 0){
                    callback(res.data)
                }
            })
        },
        createNewRound(){
            let info = {
                id:`new_${createHash()}`,
                editFlag:true,
                state:'0',   // 0 还未保存 1：未开始 2：报价中 3：已结束
            };
            return info
        },
        tableRow(row){
            return row.id
        },
        addRound(){
            // 询价轮次可以提前保存多个待发布的询价轮次数据
            this.form = {
                // id:`new_${createHash()}`,
                id:``,
                bjJzTime:null,
                remark:'',
                buyerRemark:this.orderInfo.buyerRemark,
                goodsList:[],
            };
            if(this.$refs["groundForm"] !== undefined){
                this.$refs["groundForm"].resetFields();
            }
            this.getOrderDetailList((list)=>{
                list.forEach((goods)=>{
                    goods['gysInfos']=[]
                })
                this.form.goodsList=list;
                this.openDialog=true;
                this.title = '新增报价轮次';
                console.log(this.orderInfo)
            })
        },
        // 获取当前订单的物料列表
        async getOrderDetailList(callback) {
            let _this = this;
            const {
                data: res
            } = await inquiryDetailList({
                page: 1, //当前页码
                limit: 2000, //当前每页显示的数量
                objMap: {
                    orderId: this.hId,
                }
            })
            if (res.code == 0) {
                this.getGysList();
                callback(res.data||[])
            }
        },
        // 获取轮次列表
        async getInquiryRoundList() {
            let _this = this;
            const { data: res } = await getInquiryRoundList({
                limit: 1000,
                objMap: {
                    orderId:_this.$route.query.hId, // 询价单主表主键
                },
                page: 1,
            })
            if (res.code == 0) {
                this.roundList = res.data||[];
                this.roundList.forEach((item,index)=>{
                    item['lcNum'] = this.roundList.length-index;
                })
                // 判断是否可以新增第二、三...轮报价
                if(this.orderInfo.orderState == 2 && this.checkRole('cgy_role')){
                    let isAgain = true;
                    this.roundList.forEach((item)=>{
                        if(item.status == 0 || item.status == 1){
                            isAgain = false;
                        }
                    });
                    this.$emit('callback',{type:'isAgain',isAgain}); // 更新顶部信息
                }
            }
        },
        handleSelectionChange(val) {
			this.ids = [];
			this.idsObj = {};
			for (let item of val) {
                this.ids.push(item.id);
                this.idsObj[`id_${item.id}`]=true;
			}
        },
        // 展开 行
        handleConnectionSearch() {
            this.form.goodsList.forEach((item)=>{
                if(item.gysInfos.length){
                    this.$refs.goodsTable.toggleRowExpansion(item, true) // 点击button展开
                }
            })

        },
        // 提交
        submitForm(type){
            let _this = this;
            _this.$refs['groundForm'].validate((valid) => {
                if (valid) {
                    let noGystext = '';
                    let param = {
                        orderId: _this.$route.query.hId, // 询价单主表主键
                        bjJzTime: _this.form.bjJzTime, // 报价截止时间
                        remark: _this.form.remark, // 备注
                        buyerRemark: _this.form.buyerRemark, // 采购说明
                    }
                    // if(this.orderInfo.xjFs != 1){   // 非询比价的方式 需要传物料与指定的供应商 绑定关系
                        if(this.form.goodsList.length==0){
                            noGystext = '不存在物料行，请检查'
                        }
                        param['relation'] = []; // 物料与供应商的关系结构
                        this.form.goodsList.forEach((item,index)=>{
                            let obj = {
                                srmXJOrderDetailId:item.id,
                                gysIds:[],
                            };
                            if(item.gysInfos.length){
                                item.gysInfos.forEach((gy)=>{
                                    obj.gysIds.push(gy.id);
                                });
                            }else{
                                if(this.orderInfo.xjFs != 1){
                                    if(!noGystext && _this.orderInfo.xjFs != 1){ // 询比价的方式可以不指定供应商
                                        noGystext = `第${index+1}行商品未指定供应商，请检查！`
                                    }
                                }
                            }
                            param.relation.push(obj);
                        })
                        if(noGystext){
                            _this.$message.error(noGystext)
                            return
                        };
                    // }
                    // console.log(this.form)
                    // console.log(param)
                    // return
                    if(this.form.id){   // 编辑
                        param['id'] = this.form.id;
                        editInquiryRound(param).then(response => {
                            if(response.data.code === 0){
                                _this.$message.success('编辑成功');
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'updateInfo'});
                                _this.getInquiryRoundList()
                            }
                        })
                    }else{  // 新增
                        addInquiryRound(param).then(response => {
                            if(response.data.code === 0){
                                _this.$message.success('创建成功');
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'updateInfo'});
                                _this.getInquiryRoundList()
                            }
                        })
                    }


                    // _this.$emit('callback', {type:'addround',data:_this.form});

                }
            })
        },
        // 获取供应商列表
        async getGysList(){
            let _this = this;
			const { data: res } = await supplierInfoList({
				page: 1, //当前页码
				limit: 1000, //当前每页显示的数量
			})
			if (res.code == 0) {
                let data = res.data || [],newList = [];
                data.forEach((item)=>{
                    newList.push({
                        value:item.id,
                        label:item.qyShort,
                        name:item.name,
                    })
                });
                this.gysUsers = newList;
			}
        },
        // 关联供应商
        selectSubmit(lists){
            console.log(this.selectGys)
            let selects = [];
            if(this.orderInfo.xjFs != 2){
                selects = lists|| this.selectGys;   // 竞争性谈判
            }else{
                selects = lists?[lists]:[this.selectGys];// 定向采购
            }
            console.log(selects)
            if(selects.length){
                let idObj = {};
                selects.forEach((id)=>{
                    idObj[`id_${id}`] = true;
                });
                // 已选 供应商
                let gysr = [];
                let gysrObj = {};
                if(lists){
                    selects.forEach((item)=>{
                        gysr.push({id:item.id,name:item.name,cname:item.qyShort})
                    })
                }else{
                    this.gysUsers.forEach((item)=>{
                        if(idObj[`id_${item.value}`]){
                            gysr.push({id:item.value,name:item.label,cname:item.name})
                        }
                    });
                }

                // 整理已选择的
                // 遍历物料，添加供应商
                this.form.goodsList.forEach((item)=>{
                    console.log(this.idsObj)
                    console.log(this.idsObj[`id_${item.id}`])
                    if(this.idsObj[`id_${item.id}`]){
                        // 竞争性谈判
                        if(this.orderInfo.xjFs == 3 || this.orderInfo.xjFs == 1){
                            let rowGysObj = {};
                            item.gysInfos.forEach((gy)=>{
                                rowGysObj[`id_${gy.id}`] = true;
                            });
                            gysr.forEach((gysItem)=>{
                                if(!rowGysObj[`id_${gysItem.id}`]){
                                    item.gysInfos.push(gysItem)
                                }
                            })
                        }
                        // 定向采购
                        if(this.orderInfo.xjFs == 2){
                            item.gysInfos = gysr
                        }
                    }
                })
                console.log(this.form.goodsList)
                // 已制定供应商的商品展开
                this.$refs.goodsTable.clearSelection();
                this.ids = [];
			    this.idsObj = {};
                this.handleConnectionSearch()
                this.showSelectGys = false;
            }else{
                this.$message.error('请至少选择一个供应商');
            }
        },
        // 删除供应商
        delGys(row,user){
            console.log(row)
            console.log(user)
            let list = [...this.form.goodsList]
            list.forEach((good)=>{
                if(good.id == row.id){
                    let newList = [];
                    good.gysInfos.forEach((u)=>{
                        if(u.id != user.id){
                            newList.push(u)
                        }
                    })
                    good.gysInfos = newList;
                }
            })
            this.form.goodsList = [...list]
        },
        // 移除行
        delRow(row){
            let list = [...this.form.goodsList]
            let selids = [...this.ids];
            this.ids = [];
			this.idsObj = {};
            this.form.goodsList = [];
            selids.forEach((item)=>{
                if(item != row.id){
                    this.ids.push(item);
                    this.idsObj[`id_${item}`]=true;
                }
            })
            list.forEach((l)=>{
                if(l.id != row.id){
                    this.form.goodsList.push(l)
                }
            })
            if(this.ids.length==0){
                this.showSelectGys = false;
            }
        },
        // 提交报价
        submitBj(){
            let _this = this;
            _this.confirm({
                text: '报价一经提交，将无法撤回修改，请再次确认报价无误',
                tip: '警告',
                type: '',
                fn: function(param) {
                    submitOrderBj(param).then(({data:res})=>{
                        if(res.code == 0){
                            _this.$success('提交成功');
                            _this.$emit('callback',{type:'updateInfo'}); // 更新顶部信息
                        }
                    })
                },
                data: {
                    id:_this.orderInfo.inquiryUserId
                } //参数对象 主要回调函数用
            });
        },
        EnquiryDetailCallback(obj){
            if(obj.type == 'updateInfo'){
                this.$emit('callback',{type:'updateInfo'}); // 更新顶部信息
            }
        },
        bindGys(){
            this.selectGys=[];
            this.$refs.SelectGysRef.init();
        },
        // 选择物料回调
        SelectOrderGoodsCallback(obj){
            if(obj.type == 'add'){
                // console.log(obj.data)
                let goods = {...obj.data};
                goods['gysInfos']=[];
                this.form.goodsList.push(goods);
                this.$refs.SelectOrderGoodsRef.openDialog= false;
            }
        },
        // 选择供应商回调
        SelectGysCallback(obj){
            if(obj.type == 'selgys'){
                console.log(obj.info)
                let lists = [...obj.info]
                this.selectGys = obj.info;
                 if(this.orderInfo.xjFs != 2){  // 非定向采购
                    this.selectSubmit(lists)
                }else{  // 定向采购
                    this.selectSubmit(lists[0])
                }
                this.$refs.SelectGysRef.openDialog=false;
            }
        },
        formatTaxRate: function(row) {
            if(row.taxRate || row.taxRate == 0){
                return row.taxRate+'%';
            }else{
                return ''
            }

        },
    },
    watch:{
        'showSelectGys':function(nVal){
            this.selectGys=[];
            // let prama = {
            //     orderId:'',//询价单主表主键
            //     bjJzTime:'',//报价截止时间 yyyy-MM-dd HH:mm:ss
            //     relation:[
            //         {
            //             srmXJOrderDetailId:1,   //物料id
            //             gysIds:[1,2,3]       // 指定供应商的ids
            //         },{
            //             srmXJOrderDetailId:2,   //物料id
            //             gysIds:[11,23]       // 指定供应商的ids
            //         },
            //     ],
            //     remark:'',//备注
            // }
        }
        // 'form.goodsList':function(nVal){
        //     if(nVal && nVal.length>0){
        //         let keys = [];
        //         nVal.forEach((item)=>{
        //             if(item.gysInfos.length){
        //                 keys.push(item.id)
        //             }
        //         })
        //         this.expandRowkeys = keys;
        //     }
        // }
    }
}
</script>
<style lang="scss">
    .add-ground-dialog{
        margin-bottom: 10px;
    }
    .round-list-box{
        width: 100%;
        .title-round{
            display: flex;
            justify-content: space-between;
        }
        .round-list-wrap{
            height: calc(100vh - 300px );
            overflow-y: auto;
            overflow-x: hidden;
        }
        .rount-foot{
            width: 100%;
            text-align: right;
            padding: 5px 0;
        }
        .no-round-list{
            width: 100%;
            text-align: center;

            color: #999;
        }
        .add-gys-head{
            margin-bottom:5px;
            display: flex;
            /* justify-content: space-between; */
        }
        ::v-deep .el-collapse{
            border: none;
            .el-collapse-item,.el-collapse-item.is-active{
                box-shadow: 0 0 15px 0px rgba(0,16,31,0.16);
                border-radius: 4px;
                margin: 10px;
                padding: 0 10px;
                // position: relative;
                // top:0px;
                // transition: all .3s ease 0s;
                // &:hover{
                //     top:-5px;
                //     transition: all .3s ease 0s;
                //     box-shadow: 0 0 10px 0px rgba(0,16,31,0.3);
                // }
            }
            .el-collapse-item__header,.el-collapse-item__wrap{
                border: none!important;
            }
            .el-collapse-item__content{
                padding-bottom: 3px;
            }
        }

    }
</style>


